import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'ca-file-picker',
    styleUrls: ['./file-picker.component.scss'],
    templateUrl: './file-picker.component.html',
    standalone: false
})
export class FilePickerComponent {
  @Input() loading: boolean;
  @Input() label: string;
  @Input() iconName: string;
  @Input() accept: string;
  @Input() multiple: boolean = false;
  @Output() selection = new EventEmitter<File[]>();
  @ViewChild('fileInput') fileInput;

  fileChange(event: any) {
    try {
      const files = event.target.files;
      this.selection.next(files);
    } catch (ex) {
      // ignore
    }

    // Reset the input so reusing the same file will still trigger changes
    this.fileInput.nativeElement.value = '';
  }

  pickFile(event: MouseEvent) {
    event.preventDefault();
    this.fileInput.nativeElement.click();
  }
}
